<div class="row">
  <div class="col-auto">
    <h2><i class="fas fa-user-lock"></i> Roles & Permissions</h2>
  </div>
</div>

<ng-container *ngIf="!(isLoading$ | async); else loading">
  <div class="card">
    <div class="card-body">
      <h4>Backoffice User Roles</h4>
      <app-role-list
        [roles]="userRoles$ | async"
        [permissions]="getAllBOPermissions$ | async"
        [rolesWithPermissions]="rolesPermissions$ | async"
      >
      </app-role-list>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <h4>One Account User Roles</h4>
      <app-role-list
        [roles]="accountUserRoles$ | async"
        [permissions]="getAllOnePermissions$ | async"
        [rolesWithPermissions]="rolesPermissions$ | async"
      >
      </app-role-list>
    </div>
  </div>
</ng-container>
<ng-template #loading>
  <app-loading-spinner> </app-loading-spinner>
</ng-template>
